"use client";

import Image from "next/image";
import { useTokenInfo } from "@/hooks/useTokenInfo";

interface TokenBriefProps {
	tokenId: string;
	className?: string;
	textClassName?: string;
}

export function TokenBrief({ tokenId, className, textClassName }: TokenBriefProps) {
	const { tokenInfo, isLoading } = useTokenInfo(tokenId);

	return (
		<div className={`flex items-center gap-1.5 min-w-0 ${className || ""}`}>
			<div className="relative w-4 h-4 flex-shrink-0">
				<Image
					src={`https://images.odin.fun/token/${tokenId}`}
					alt={tokenId}
					fill
					className="rounded-full object-cover"
					unoptimized
				/>
			</div>
			<div className={`flex items-center gap-1 truncate ${textClassName || ""}`}>
				<span className="font-bold truncate">
					{isLoading ? "..." : (tokenInfo?.ticker || "Token")}
				</span>
				<span className="opacity-60 text-[10px] font-mono shrink-0">
					({tokenId})
				</span>
			</div>
		</div>
	);
}
